import script from "./Drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Drawer.vue?vue&type=script&lang=ts&setup=true"

import "./Drawer.vue?vue&type=style&index=0&id=4ecfa7ea&lang=scss"

const __exports__ = script;

export default __exports__